export default "__VITE_ASSET__557f4854__"